import "./lib/flowtype";
import "../../node_modules/jquery-custom-select/dist/js/jquery.custom-select.min";
import "../../node_modules/inputmask/dist/jquery.inputmask.min";
import bootstrap from '../../node_modules/bootstrap/dist/js/bootstrap.min';
import gsap from '../../node_modules/gsap/dist/gsap.min';
import ScrollToPlugin from '../../node_modules/gsap/dist/ScrollToPlugin.min';
import Swiper from '../../node_modules/swiper/swiper-bundle';
import imagesLoaded from '../../node_modules/imagesloaded/imagesloaded.pkgd.min';
import alertify from '../../node_modules/alertifyjs/build/alertify.min';
var $ = require('jquery');
gsap.registerPlugin(ScrollToPlugin);
imagesLoaded.makeJQueryPlugin( $ );
(function( root, $, undefined ) {
'use strict';

$(function(){
let PathUrl = $("body").attr("data-path"),
SiteUrl = $("body").attr("url-path");
let WindowHeight = function(){
$('.get_height').css({'min-height':  window.innerHeight+ 'px'});
$('.get_mid_height').css({'min-height':  window.innerHeight/2+ 'px'});
$('.get_width').css({'min-width':  window.innerWidth+ 'px'});
$('.wrapp-menu-mobile').css({'padding-top': $(".mobile-menu").outerHeight(true)});
};

WindowHeight();

alertify.dialog('alert').set({maximizable: false, resizable:false, movable:false, title:"Desafio alerta :",transition:"zoom",closable:false});
alertify.dialog('confirm').set({maximizable: false, resizable:false, movable:false, title:"Desafio confirmación :",transition:"zoom",closable:false});
alertify.set('notifier','position', 'bottom-right');
alertify.set('notifier','delay',5);

$("#UserPhone").inputmask({ mask: "+56\\9\\ 9999-9999", greedy: false});

$("#UserEmail").inputmask({
mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]",
greedy: false,
onBeforePaste: function (pastedValue, opts) {
pastedValue = pastedValue.toLowerCase();
return pastedValue.replace("mailto:", "");
},
definitions: {
'*': {
validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
casing: "lower"
}
}
});

$('#wrapper').imagesLoaded()
.always( function( instance ) {
    setTimeout(function() { 
        $(".preloader").fadeOut("fast");
		window.scrollTo(0, 0);
        if(window.location.hash){
			var hash_scroll = window.location.hash;
			gsap.to(window, { duration: 1, scrollTo: { y: hash_scroll, offsetY: $(".header-desafio:visible").outerHeight()+100 }});
			location.hash = "";
			history.replaceState("", "", location.pathname);
		}
    }, 300);
});

var menu = gsap.timeline({paused: true});
menu.to(".wrapp-menu-mobile", {left: "0%", opacity:1, autoAlpha:1, duration: 0.4,},0);
menu.to(".wrapp-menu-mobile .menu-mobile", {left: "0px", opacity:1, duration: 0.4},0.3);

$('.bt-menu').on('click', function(e) {
e.preventDefault();
$('body').toggleClass('menu-open');
if($("body").hasClass('menu-open')){
    menu.play();
}else{
    menu.reverse();
}
});

let shrinkHeader = 100;
$(window).on("scroll",function() {
let scroll = getCurrentScroll();
if ( scroll >= shrinkHeader ) {
$('.desktop-menu').addClass('active');
}
else {
$('.desktop-menu').removeClass('active');
}
});
function getCurrentScroll() {
return window.scrollY;
}

$('.titulo-banner').flowtype({
fontRatio : 18,
minFont : 40,
});

$('.titulo-baguette').flowtype({
fontRatio : 18,
minFont : 40,
});

$('.titulo-temas').flowtype({
fontRatio : 18,
minFont : 40,
});

$('.titulo-futuros').flowtype({
fontRatio : 18,
minFont : 40,
});

$('.titulo-tus-temas').flowtype({
fontRatio : 18,
minFont : 40,
});

var temasfuturos = new Swiper(".desafio-slide", {
slidesPerView: 3,
spaceBetween: 30,
centeredSlides: true,
navigation: {
nextEl: ".swiper-button-next",
prevEl: ".swiper-button-prev",
},
breakpoints: {
    320: {
        slidesPerView: 1,
    },
    480: {
        slidesPerView: 1,
    },
    768: {
        slidesPerView: 2,
    },
    1024: {
        slidesPerView: 2,
    },
    1140: {
        slidesPerView: 3,
    },
    1280: {
        slidesPerView: 3,
    },
},
});


$("#EnvSuger").on("click",function(e){
e.preventDefault();

if($("#UserName").val().length < 4) {  
alertify.alert("Ingresa tu nombre completo.").set('label', 'Aceptar');  
return false;  
}
if($("#UserEmail").val().length < 1) {  
alertify.alert("Ingresa tu email.").set('label', 'Aceptar');   
return false;  
}  
if($("#UserEmail").val().indexOf('@', 0) == -1 || $("#UserEmail").val().indexOf('.', 0) == -1) {  
alertify.alert("El email ingresado contiene errores.").set('label', 'Aceptar');  
return false;  
}
if($("#UserPhone").val().length < 4) {  
alertify.alert("Ingresa tu teléfono.").set('label', 'Aceptar');  
return false;  
}
if($("#UserPhone").val().replace(/[^0-9]/g,"").length < 11) { 
alertify.alert("Ingresa un teléfono valido.").set('label', 'Aceptar');  
return false;   
}
if($("#UserTheme").val().length < 12) {  
alertify.alert("Ingresa tu propuesta (mínimo 12 caracteres).").set('label', 'Aceptar');  
return false;  
}

$("#EnvSuger").prop('disabled', true);
let action = 'EnvSuger',
UserName = $("#UserName").val(),
UserEmail = $("#UserEmail").val(),
UserPhone = $("#UserPhone").val(),
UserTheme = $("#UserTheme").val(),
data = {action:action, UserName:UserName, UserEmail:UserEmail, UserPhone:UserPhone, UserTheme:UserTheme};
$.ajax({
data:  data,
url:   SiteUrl+'/json',
type:  'post',
cache: false,
beforeSend: function() {
gsap.to($(".preload-form"), {opacity:1, autoAlpha:1, duration: 0.5});
},
success:function(response) {
$("#EnvSuger").prop('disabled', false);
gsap.to($(".preload-form"), {opacity:0, autoAlpha:0, duration: 0.5});
if(response.status == "success"){
alertify.alert("Sugerencia enviada con éxito.").set('label', 'Aceptar');
$("#UserName").val("");
$("#UserEmail").val("");
$("#UserPhone").val("");
$("#UserTheme").val("");
return false;  
}else if(response.status == "error"){
$("#EnvSuger").prop('disabled', false);
alertify.alert("Error al enviar sugerencia.").set('label', 'Aceptar');  
return false;  
}
}
});
});

$(window).on('resize', function(){
WindowHeight();
});

$(window).on('load', function(){
WindowHeight();
window.scrollTo(0, 0);
});

});
}(this, jQuery));